var map = {
	"./agentassist/logo.png": 15526,
	"./basset/logo.png": 60320,
	"./bcx/logo.png": 66349,
	"./blueoak/logo.png": 63685,
	"./default/logo.png": 7561,
	"./eskom/logo.png": 86725,
	"./ezconnect/logo.png": 54015,
	"./momentum/logo.png": 93128,
	"./secumed/logo.png": 43882,
	"./tigerbrands/logo.png": 24097,
	"./tongaat/logo.png": 1460,
	"./xib-demo/logo.png": 91899
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77497;